import {useState, useEffect} from 'react';
import {
  Plan,
  CheckoutStep,
  UseAccountCheckoutReturn,
} from './AccountCheckout.type';
import {GetPlanInfo} from '../../../services/account/AccountCheckout.service';

export const useAccountCheckout = (
  plans: Plan[],
  accountLabel: string,
): UseAccountCheckoutReturn => {
  const [loading, setLoading] = useState(false);
  const [purchased, setPurchased] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const [currentStep, setCurrentStep] = useState<CheckoutStep>('plan');

  const filteredPlans =
    plans?.filter(
      (plan) => plan.code !== null && !!plan.externalPlans?.length,
    ) || [];
  const urlPlan = new URLSearchParams(window.location.search).get('plan');

  useEffect(() => {
    if (accountLabel) {
      document.title = `${accountLabel} Checkout - Personal Millbody`;
    }

    if (urlPlan) {
      selectPlan(urlPlan);
    }
  }, []);

  useEffect(() => {
    if (selectedPlan === null) {
      document.title = `${accountLabel} Checkout - Personal Millbody`;
    }
  }, [selectedPlan]);

  const selectPlan = (planCode: string) => {
    GetPlanInfo(planCode, setLoading).then(({plan: planConsulted}) => {
      if (planConsulted) {
        setSelectedPlan(planConsulted);
        setCurrentStep('personal');
      }
    });
  };

  return {
    loading,
    purchased,
    selectedPlan,
    currentStep,
    filteredPlans,
    selectPlan,
    setCurrentStep,
    setPurchased,
    setLoading,
  };
};
